import { render, staticRenderFns } from "./maintainrecordhistory.vue?vue&type=template&id=b8193ec4&scoped=true&"
import script from "./maintainrecordhistory.vue?vue&type=script&lang=ts&"
export * from "./maintainrecordhistory.vue?vue&type=script&lang=ts&"
import style0 from "./maintainrecordhistory.vue?vue&type=style&index=0&id=b8193ec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8193ec4",
  null
  
)

export default component.exports